import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface AchievementState {
  dismissedAchievements: Record<string, boolean>;
  isMinimized: boolean;
  
  dismissAchievement: (achievementId: string) => void;
  isDismissed: (achievementId: string) => boolean;
  setMinimized: (minimized: boolean) => void;
}

export const useAchievementStore = create<AchievementState>()(
  persist(
    (set, get) => ({
      dismissedAchievements: {},
      isMinimized: false,
      
      dismissAchievement: (achievementId: string) => {
        set((state) => ({
          dismissedAchievements: {
            ...state.dismissedAchievements,
            [achievementId]: true,
          },
        }));
      },
      
      isDismissed: (achievementId: string) => {
        return get().dismissedAchievements[achievementId] === true;
      },
      
      setMinimized: (minimized: boolean) => {
        set({ isMinimized: minimized });
      },
    }),
    {
      name: 'achievement-storage',
    }
  )
);
